import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchDialogComponent } from '@app/shared/components/search-dialog/search-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SearchDialogService {

  constructor(private readonly dialog: MatDialog) { }

  public openSearchDialog(): void {
    this.dialog.open(SearchDialogComponent, {
      panelClass: ['dialog-no-padding', 'dialog-base-radius', 'dialog-light-box-shadow', 'mobile-full-width-dialog']
    });
  }

}